import React from 'react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

const ShowMoreButton = ({
  label,
  onClick,
  className = '',
  fullWidthOnMobile = true,
  icon = true,
  disabled = false,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-haspopup="dialog"
      className={[
        'inline-flex items-center justify-center gap-2',
        fullWidthOnMobile ? 'w-full sm:w-auto' : '',
        'px-4 py-2 rounded-xl',
        'bg-gray-100 text-gray-900',
        'hover:bg-gray-200',
        'border border-transparent hover:border-gray-300',
        'font-semibold text-sm',
        'transition',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-500 focus-visible:ring-offset-2',
        disabled ? 'opacity-50 cursor-not-allowed' : '',
        className,
      ].join(' ')}
    >
      <span>{label}</span>
      {icon && <ChevronRightIcon className="w-4 h-4" />}
    </button>
  );
};

export default ShowMoreButton;
